import React from 'react'
import './style.scss'
const index = () => {
  return (
    <div id='social-media-bar'>
      <div className='float-sm'>
        <div className='fl-fl float-fb'>
          <i className='fa fa-facebook'></i>
          <a href='https://www.facebook.com/azcabuilders' target='_blank'>
            Like us!
          </a>
        </div>
        <div className='fl-fl float-tw'>
          <i className='fa fa-twitter'></i>
          <a href='https://twitter.com/azcaestate' target='_blank'>
            Follow us!
          </a>
        </div>
        {/* <div className="fl-fl float-gp">
          <i className="fa fa-google-plus"></i>
          <a href="https://www.instagram.com/azcapk/" target="_blank">
            Recommend us!
          </a>
        </div> */}
        <div className='fl-fl float-gp'>
          <i className='fa fa-instagram'></i>
          <a href='https://www.instagram.com/azcabuilders/' target='_blank'>
            Follow us!
          </a>
        </div>
        <div className='fl-fl float-rs'>
          <i className='fa fa-youtube'></i>
          <a
            href='https://www.youtube.com/channel/UCKgPzNfQjLK8TJ2nNvPRDWA'
            target='_blank'
          >
            Subscribe us!
          </a>
        </div>
        <div className='fl-fl float-ig'>
          <i className='fa fa-phone-square'></i>
          <a href='tel:051-5400175-6'>Contact us!</a>
        </div>
      </div>
    </div>
  )
}

export default index
